export default __webpack_public_path__ + "static/media/rote_forella_portrait.5dfe4766.jpg";